"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deZones = exports.deSubZoneNameMapping = void 0;
var deZones = exports.deZones = [{
  id: 'BERLIN',
  name: 'Berlin',
  country: 'DE',
  cornerNW: {
    latitude: 52.6755,
    longitude: 13.0884
  },
  cornerSE: {
    latitude: 52.3379,
    longitude: 13.7613
  },
  subZones: [{
    name: 'Mitte',
    zipcodes: {
      10115: {
        label: 'Gesundbrunnen, Mitte, Moabit'
      },
      10117: {
        label: 'Mitte'
      },
      10119: {
        label: 'Mitte'
      },
      10178: {
        label: 'Mitte'
      },
      10179: {
        label: 'Mitte'
      },
      10551: {
        label: 'Moabit'
      },
      10553: {
        label: 'Moabit'
      },
      10555: {
        label: 'Moabit'
      },
      10557: {
        label: 'Moabit, Tiergarten'
      },
      10559: {
        label: 'Moabit'
      },
      10785: {
        label: 'Tiergarten'
      },
      10787: {
        label: 'Tiergarten'
      },
      13347: {
        label: 'Wedding'
      },
      13349: {
        label: 'Wedding'
      },
      13351: {
        label: 'Wedding'
      },
      13353: {
        label: 'Wedding'
      },
      13355: {
        label: 'Gesundbrunnen, Wedding'
      },
      13357: {
        label: 'Gesundbrunnen'
      }
    }
  }, {
    name: 'Friedrichshain-Kreuzberg',
    zipcodes: {
      10243: {
        label: 'Friedrichshain'
      },
      10245: {
        label: 'Friedrichshain'
      },
      10247: {
        label: 'Friedrichshain'
      },
      10249: {
        label: 'Friedrichshain'
      },
      10961: {
        label: 'Kreuzberg'
      },
      10963: {
        label: 'Kreuzberg'
      },
      10965: {
        label: 'Kreuzberg'
      },
      10967: {
        label: 'Kreuzberg'
      },
      10969: {
        label: 'Kreuzberg'
      },
      10997: {
        label: 'Kreuzberg'
      },
      10999: {
        label: 'Kreuzberg'
      }
    }
  }, {
    name: 'Pankow',
    zipcodes: {
      10405: {
        label: 'Prenzlauer Berg'
      },
      10407: {
        label: 'Prenzlauer Berg, Weissensee'
      },
      10409: {
        label: 'Prenzlauer Berg'
      },
      10435: {
        label: 'Prenzlauer Berg'
      },
      10437: {
        label: 'Prenzlauer Berg'
      },
      10439: {
        label: 'Prenzlauer Berg'
      },
      13051: {
        label: 'Stadtrandsiedlung Malchow'
      },
      13086: {
        label: 'Weissensee'
      },
      13088: {
        label: 'Weissensee'
      },
      13089: {
        label: 'Heinersdorf, Weissensee'
      },
      13125: {
        label: 'Buch, Karow'
      },
      13127: {
        label: 'Französisch Buchholz, Karow'
      },
      13129: {
        label: 'Blankenburg'
      },
      13156: {
        label: 'Niederschönhausen, Pankow, Rosenthal'
      },
      13158: {
        label: 'Niederschönhausen, Rosenthal, Wilhelmsruh'
      },
      13159: {
        label: 'Blankenfelde, Französisch Buchholz, Rosenthal'
      },
      13187: {
        label: 'Pankow'
      },
      13189: {
        label: 'Pankow'
      }
    }
  }, {
    name: 'Charlottenburg-Wilmersdorf',
    zipcodes: {
      10585: {
        label: 'Charlottenburg'
      },
      10587: {
        label: 'Charlottenburg'
      },
      10589: {
        label: 'Charlottenburg'
      },
      10623: {
        label: 'Charlottenburg'
      },
      10625: {
        label: 'Charlottenburg'
      },
      10627: {
        label: 'Charlottenburg'
      },
      10629: {
        label: 'Charlottenburg'
      },
      10707: {
        label: 'Charlottenburg, Wilmersdorf'
      },
      10709: {
        label: 'Halensee, Wilmersdorf'
      },
      10711: {
        label: 'Halensee'
      },
      10713: {
        label: 'Wilmersdorf'
      },
      10715: {
        label: 'Wilmersdorf'
      },
      10717: {
        label: 'Wilmersdorf'
      },
      10719: {
        label: 'Charlottenburg, Wilmersdorf'
      },
      10777: {
        label: 'Wilmersdorf'
      },
      10779: {
        label: 'Wilmersdorf'
      },
      10789: {
        label: 'Charlottenburg'
      },
      14050: {
        label: 'Westend'
      },
      14052: {
        label: 'Charlottenburg, Westend'
      },
      14053: {
        label: 'Westend'
      },
      14055: {
        label: 'Charlottenburg, Grunewald, Westend'
      },
      14057: {
        label: 'Charlottenburg'
      },
      14059: {
        label: 'Charlottenburg'
      },
      14193: {
        label: 'Grunewald'
      },
      14199: {
        label: 'Schmargendorf'
      }
    }
  }, {
    name: 'Spandau',
    zipcodes: {
      13581: {
        label: 'Spandau'
      },
      13583: {
        label: 'Spandau, Falkenhagener Feld'
      },
      13585: {
        label: 'Spandau, Falkenhagener Feld'
      },
      13587: {
        label: 'Spandau, Hakenfelde'
      },
      13589: {
        label: 'Spandau, Falkenhagener Feld'
      },
      13591: {
        label: 'Staaken'
      },
      13593: {
        label: 'Wilhelmstadt, Staaken'
      },
      13595: {
        label: 'Wilhelmstadt'
      },
      13597: {
        label: 'Spandau, Staaken, Wilhelmstadt'
      },
      13599: {
        label: 'Haselhorst'
      },
      13629: {
        label: 'Siemensstadt'
      },
      14089: {
        label: 'Gatow, Kladow'
      }
    }
  }, {
    name: 'Steglitz-Zehlendorf',
    zipcodes: {
      12157: {
        label: 'Steglitz'
      },
      12161: {
        label: 'Steglitz'
      },
      12163: {
        label: 'Steglitz'
      },
      12165: {
        label: 'Steglitz'
      },
      12167: {
        label: 'Steglitz'
      },
      12169: {
        label: 'Steglitz'
      },
      12203: {
        label: 'Lichterfelde'
      },
      12205: {
        label: 'Lichterfelde'
      },
      12207: {
        label: 'Lichterfelde'
      },
      12209: {
        label: 'Lichterfelde'
      },
      12247: {
        label: 'Lankwitz'
      },
      12249: {
        label: 'Lankwitz'
      },
      14109: {
        label: 'Wannsee'
      },
      14129: {
        label: 'Nikolassee, Schlachtensee'
      },
      14163: {
        label: 'Zehlendorf'
      },
      14165: {
        label: 'Zehlendorf'
      },
      14167: {
        label: 'Zehlendorf'
      },
      14169: {
        label: 'Zehlendorf, Dahlem'
      },
      14195: {
        label: 'Dahlem'
      }
    }
  }, {
    name: 'Tempelhof-Schöneberg',
    zipcodes: {
      10781: {
        label: 'Schöneberg'
      },
      10783: {
        label: 'Schöneberg'
      },
      10785: {
        label: 'Schöneberg'
      },
      10787: {
        label: 'Schöneberg'
      },
      10789: {
        label: 'Schöneberg'
      },
      10823: {
        label: 'Schöneberg'
      },
      10825: {
        label: 'Schöneberg'
      },
      10827: {
        label: 'Schöneberg'
      },
      10829: {
        label: 'Schöneberg'
      },
      12101: {
        label: 'Tempelhof'
      },
      12103: {
        label: 'Tempelhof'
      },
      12105: {
        label: 'Tempelhof, Mariendorf'
      },
      12107: {
        label: 'Mariendorf'
      },
      12109: {
        label: 'Mariendorf'
      },
      12157: {
        label: 'Friedenau'
      },
      12159: {
        label: 'Friedenau'
      },
      12161: {
        label: 'Friedenau'
      },
      12163: {
        label: 'Friedenau'
      },
      12165: {
        label: 'Friedenau'
      },
      12167: {
        label: 'Friedenau'
      },
      12169: {
        label: 'Friedenau'
      },
      12277: {
        label: 'Mariendorf, Marienfelde'
      },
      12279: {
        label: 'Marienfelde'
      },
      12281: {
        label: 'Marienfelde'
      },
      12305: {
        label: 'Lichtenrade'
      },
      12307: {
        label: 'Lichtenrade'
      },
      12309: {
        label: 'Lichtenrade'
      }
    }
  }, {
    name: 'Neukölln',
    zipcodes: {
      12043: {
        label: 'Neukölln'
      },
      12045: {
        label: 'Neukölln'
      },
      12047: {
        label: 'Neukölln'
      },
      12049: {
        label: 'Neukölln'
      },
      12051: {
        label: 'Neukölln'
      },
      12053: {
        label: 'Neukölln'
      },
      12055: {
        label: 'Neukölln'
      },
      12057: {
        label: 'Neukölln'
      },
      12059: {
        label: 'Neukölln'
      },
      12347: {
        label: 'Britz'
      },
      12349: {
        label: 'Britz, Buckow'
      },
      12351: {
        label: 'Buckow, Gropiusstadt'
      },
      12353: {
        label: 'Gropiusstadt'
      },
      12355: {
        label: 'Rudow'
      },
      12357: {
        label: 'Rudow'
      },
      12359: {
        label: 'Britz'
      }
    }
  }, {
    name: 'Treptow-Köpenick',
    zipcodes: {
      12435: {
        label: 'Alt-Treptow'
      },
      12437: {
        label: 'Plänterwald, Baumschulenweg'
      },
      12439: {
        label: 'Niederschöneweide'
      },
      12459: {
        label: 'Oberschöneweide'
      },
      12487: {
        label: 'Johannisthal'
      },
      12489: {
        label: 'Adlershof'
      },
      12521: {
        label: 'Grünau'
      },
      12524: {
        label: 'Altglienicke'
      },
      12526: {
        label: 'Bohnsdorf, Altglienicke'
      },
      12527: {
        label: 'Schmöckwitz'
      },
      12555: {
        label: 'Köpenick'
      },
      12557: {
        label: 'Köpenick'
      },
      12559: {
        label: 'Köpenick, Müggelheim, Rahnsdorf'
      },
      12587: {
        label: 'Friedrichshagen'
      },
      12589: {
        label: 'Rahnsdorf'
      }
    }
  }, {
    name: 'Marzahn-Hellersdorf',
    zipcodes: {
      12619: {
        label: 'Hellersdorf'
      },
      12621: {
        label: 'Kaulsdorf'
      },
      12623: {
        label: 'Kaulsdorf, Mahlsdorf'
      },
      12627: {
        label: 'Hellersdorf, Mahlsdorf'
      },
      12629: {
        label: 'Hellersdorf, Kaulsdorf'
      },
      12679: {
        label: 'Marzahn'
      },
      12681: {
        label: 'Marzahn'
      },
      12683: {
        label: 'Biesdorf'
      },
      12685: {
        label: 'Biesdorf, Marzahn'
      },
      12687: {
        label: 'Marzahn'
      },
      12689: {
        label: 'Marzahn'
      }
    }
  }, {
    name: 'Lichtenberg',
    zipcodes: {
      10315: {
        label: 'Friedrichsfelde, Lichtenberg'
      },
      10317: {
        label: 'Lichtenberg, Rummelsburg'
      },
      10318: {
        label: 'Karlshorst'
      },
      10319: {
        label: 'Friedrichsfelde'
      },
      10365: {
        label: 'Lichtenberg'
      },
      10367: {
        label: 'Lichtenberg, Fennpfuhl'
      },
      10369: {
        label: 'Fennpfuhl'
      },
      13053: {
        label: 'Alt-Hohenschönhausen'
      },
      13055: {
        label: 'Alt-Hohenschönhausen'
      },
      13057: {
        label: 'Alt-Hohenschönhausen'
      }
    }
  }, {
    name: 'Reinickendorf',
    zipcodes: {
      13403: {
        label: 'Reinickendorf'
      },
      13405: {
        label: 'Tegel'
      },
      13407: {
        label: 'Reinickendorf, Wittenau'
      },
      13409: {
        label: 'Reinickendorf'
      },
      13435: {
        label: 'Waidmannslust, Wittenau'
      },
      13437: {
        label: 'Wittenau'
      },
      13439: {
        label: 'Märkisches Viertel, Wittenau'
      },
      13465: {
        label: 'Frohnau'
      },
      13467: {
        label: 'Hermsdorf, Waidmannslust'
      },
      13469: {
        label: 'Lübars, Waidmannslust, Wittenau'
      },
      13503: {
        label: 'Heiligensee, Konradshöhe, Tegel'
      },
      13505: {
        label: 'Konradshöhe, Tegel'
      },
      13507: {
        label: 'Tegel'
      },
      13509: {
        label: 'Borsigwalde, Tegel'
      }
    }
  }]
}, {
  id: 'COLOGNE',
  name: 'Cologne',
  country: 'DE',
  cornerNW: {
    latitude: 51.0244,
    longitude: 6.8271
  },
  cornerSE: {
    latitude: 50.8803,
    longitude: 7.1137
  },
  subZones: [{
    name: 'Innenstadt',
    zipcodes: {
      50667: {
        label: 'Altstadt-Nord'
      },
      50668: {
        label: 'Altstadt-Nord, Neustadt-Nord'
      },
      50670: {
        label: 'Neustadt-Nord'
      },
      50672: {
        label: 'Neustadt-Nord'
      },
      50674: {
        label: 'Neustadt-Süd'
      },
      50676: {
        label: 'Altstadt-Süd, Neustadt-Süd'
      },
      50677: {
        label: 'Neustadt-Süd'
      },
      50678: {
        label: 'Altstadt-Süd, Neustadt-Süd'
      },
      50679: {
        label: 'Deutz'
      }
    }
  }, {
    name: 'Rodenkirchen',
    zipcodes: {
      50968: {
        label: 'Bayenthal, Marienburg'
      },
      50996: {
        label: 'Rodenkirchen, Hahnwald, Weiß, Sürth'
      },
      50997: {
        label: 'Meschenich, Rondorf, Immendorf, Godorf'
      },
      50999: {
        label: 'Weiß, Sürth, Hahnwald'
      }
    }
  }, {
    name: 'Lindenthal',
    zipcodes: {
      50931: {
        label: 'Lindenthal'
      },
      50933: {
        label: 'Braunsfeld, Müngersdorf'
      },
      50935: {
        label: 'Sülz, Klettenberg, Lindenthal'
      },
      50937: {
        label: 'Sülz'
      },
      50939: {
        label: 'Klettenberg'
      }
    }
  }, {
    name: 'Ehrenfeld',
    zipcodes: {
      50823: {
        label: 'Ehrenfeld'
      },
      50825: {
        label: 'Ehrenfeld, Bickendorf'
      },
      50827: {
        label: 'Bickendorf, Ossendorf'
      },
      50829: {
        label: 'Ossendorf, Vogelsang'
      }
    }
  }, {
    name: 'Nippes',
    zipcodes: {
      50733: {
        label: 'Nippes, Neustadt-Nord'
      },
      50735: {
        label: 'Niehl'
      },
      50737: {
        label: 'Weidenpesch, Mauenheim'
      },
      50739: {
        label: 'Longerich, Bilderstöckchen'
      }
    }
  }, {
    name: 'Chorweiler',
    zipcodes: {
      50765: {
        label: 'Esch, Pesch, Auweiler'
      },
      50767: {
        label: 'Volkhoven/Weiler, Heimersdorf, Seeberg'
      },
      50769: {
        label: 'Chorweiler, Blumenberg, Roggendorf/Thenhoven, Worringen, Fühlingen, Merkenich, Lindweiler'
      }
    }
  }, {
    name: 'Porz',
    zipcodes: {
      51143: {
        label: 'Porz, Zündorf, Lind'
      },
      51145: {
        label: 'Eil, Finkenberg, Gremberghoven'
      },
      51147: {
        label: 'Urbach, Elsdorf, Grengel, Wahn, Wahnheide, Lind'
      },
      51149: {
        label: 'Ensen, Westhoven'
      }
    }
  }, {
    name: 'Kalk',
    zipcodes: {
      51103: {
        label: 'Kalk, Höhenberg'
      },
      51105: {
        label: 'Poll, Humboldt/Gremberg, Vingst'
      },
      51107: {
        label: 'Ostheim, Rath/Heumar'
      },
      51109: {
        label: 'Brück, Merheim, Neubrück'
      }
    }
  }, {
    name: 'Mülheim',
    zipcodes: {
      51061: {
        label: 'Flittard, Stammheim'
      },
      51063: {
        label: 'Mülheim, Buchforst, Buchheim'
      },
      51065: {
        label: 'Höhenhaus, Holweide, Dellbrück'
      },
      51067: {
        label: 'Dellbrück, Holweide'
      },
      51069: {
        label: 'Dünnwald, Höhenhaus'
      }
    }
  }, {
    name: 'Cologne',
    zipcodes: {
      50667: {
        label: 'Innenstadt'
      },
      50668: {
        label: 'Neustadt-Nord'
      },
      50670: {
        label: 'Neustadt-Süd'
      },
      50672: {
        label: 'Ehrenfeld'
      },
      50674: {
        label: 'Lindenthal'
      }
    }
  }]
}, {
  id: 'DORTMUND',
  name: 'Dortmund',
  country: 'DE',
  cornerNW: {
    latitude: 51.5718,
    longitude: 7.3688
  },
  cornerSE: {
    latitude: 51.4347,
    longitude: 7.6299
  },
  subZones: [{
    name: 'Dortmund',
    zipcodes: {
      44135: {
        label: 'Innenstadt-West'
      },
      44137: {
        label: 'Innenstadt-Ost'
      },
      44139: {
        label: 'Innenstadt-Nord'
      },
      44141: {
        label: 'Innenstadt-Süd'
      },
      44145: {
        label: 'Innenstadt'
      }
    }
  }]
}, {
  id: 'DUSSELDORF',
  name: 'Düsseldorf',
  country: 'DE',
  cornerNW: {
    latitude: 51.3037,
    longitude: 6.7132
  },
  cornerSE: {
    latitude: 51.1601,
    longitude: 6.9357
  },
  subZones: [{
    name: 'Düsseldorf',
    zipcodes: {
      40210: {
        label: 'Stadtmitte'
      },
      40211: {
        label: 'Pempelfort'
      },
      40213: {
        label: 'Carlstadt'
      },
      40215: {
        label: 'Friedrichstadt'
      },
      40217: {
        label: 'Unterbilk'
      }
    }
  }]
}, {
  id: 'ESSEN',
  name: 'Essen',
  country: 'DE',
  cornerNW: {
    latitude: 51.5349,
    longitude: 6.9097
  },
  cornerSE: {
    latitude: 51.3894,
    longitude: 7.1276
  },
  subZones: [{
    name: 'Essen',
    zipcodes: {
      45127: {
        label: 'Stadtkern'
      },
      45128: {
        label: 'Südviertel'
      },
      45130: {
        label: 'Rüttenscheid'
      },
      45131: {
        label: 'Holsterhausen'
      },
      45133: {
        label: 'Bredeney'
      }
    }
  }]
}, {
  id: 'FRANKFURT',
  name: 'Francfort',
  country: 'DE',
  cornerNW: {
    latitude: 50.2271,
    longitude: 8.4724
  },
  cornerSE: {
    latitude: 50.0153,
    longitude: 8.8004
  },
  subZones: [{
    name: 'Innenstadt I',
    zipcodes: {
      60308: {
        label: 'Innenstadt I'
      },
      60311: {
        label: 'Innenstadt I'
      },
      60313: {
        label: 'Innenstadt I'
      },
      60322: {
        label: 'Innenstadt I'
      }
    }
  }, {
    name: 'Innenstadt II',
    zipcodes: {
      60325: {
        label: 'Innenstadt II'
      },
      60329: {
        label: 'Innenstadt II'
      }
    }
  }, {
    name: 'Innenstadt III',
    zipcodes: {
      60323: {
        label: 'Innenstadt III'
      },
      60326: {
        label: 'Innenstadt III'
      }
    }
  }, {
    name: 'Bornheim/Ostend',
    zipcodes: {
      60314: {
        label: 'Ostend'
      },
      60316: {
        label: 'Bornheim, Ostend'
      },
      60385: {
        label: 'Bornheim'
      },
      60386: {
        label: 'Ostend'
      }
    }
  }, {
    name: 'Süd',
    zipcodes: {
      60528: {
        label: 'Süd'
      },
      60529: {
        label: 'Süd'
      },
      60594: {
        label: 'Süd'
      },
      60596: {
        label: 'Süd'
      },
      60598: {
        label: 'Süd'
      },
      60599: {
        label: 'Süd'
      }
    }
  }, {
    name: 'West',
    zipcodes: {
      65929: {
        label: 'West'
      },
      65931: {
        label: 'West'
      },
      65933: {
        label: 'West'
      },
      65934: {
        label: 'West'
      },
      65936: {
        label: 'West'
      }
    }
  }, {
    name: 'Mitte-West',
    zipcodes: {
      60486: {
        label: 'Mitte-West'
      },
      60487: {
        label: 'Mitte-West'
      },
      60488: {
        label: 'Mitte-West'
      }
    }
  }, {
    name: 'Nord-West',
    zipcodes: {
      60439: {
        label: 'Nord-West'
      }
    }
  }, {
    name: 'Mitte-Nord',
    zipcodes: {
      60431: {
        label: 'Mitte-Nord'
      },
      60439: {
        label: 'Mitte-Nord'
      }
    }
  }, {
    name: 'Nord-Ost',
    zipcodes: {
      60320: {
        label: 'Nord-Ost'
      },
      60385: {
        label: 'Nord-Ost'
      },
      60433: {
        label: 'Nord-Ost'
      }
    }
  }, {
    name: 'Ost',
    zipcodes: {
      60314: {
        label: 'Ost'
      },
      60385: {
        label: 'Ost'
      },
      60386: {
        label: 'Ost'
      },
      60389: {
        label: 'Ost'
      }
    }
  }, {
    name: 'Kalbach-Riedberg',
    zipcodes: {
      60438: {
        label: 'Kalbach-Riedberg'
      }
    }
  }, {
    name: 'Nieder-Erlenbach',
    zipcodes: {
      60437: {
        label: 'Nieder-Erlenbach'
      }
    }
  }, {
    name: 'Harheim',
    zipcodes: {
      60437: {
        label: 'Harheim'
      }
    }
  }, {
    name: 'Nieder-Eschbach',
    zipcodes: {
      60437: {
        label: 'Nieder-Eschbach'
      }
    }
  }, {
    name: 'Bergen-Enkheim',
    zipcodes: {
      60388: {
        label: 'Bergen-Enkheim'
      }
    }
  }]
}, {
  id: 'HAMBURG',
  name: 'Hambourg',
  country: 'DE',
  cornerNW: {
    latitude: 53.6644,
    longitude: 9.7580
  },
  cornerSE: {
    latitude: 53.4037,
    longitude: 10.3241
  },
  subZones: [{
    name: 'Hamburg-Mitte',
    zipcodes: {
      20095: {
        label: 'Hamburg-Altstadt'
      },
      20097: {
        label: 'Hammerbrook'
      },
      20099: {
        label: 'St. Georg'
      },
      20457: {
        label: 'HafenCity'
      },
      20459: {
        label: 'Neustadt'
      }
    }
  }, {
    name: 'Altona',
    zipcodes: {
      20357: {
        label: 'Altona'
      },
      22765: {
        label: 'Altona-Altstadt'
      },
      22767: {
        label: 'Altona-Altstadt'
      },
      22769: {
        label: 'Altona-Nord'
      }
    }
  }, {
    name: 'Eimsbüttel',
    zipcodes: {
      20144: {
        label: 'Eimsbüttel'
      },
      20253: {
        label: 'Eimsbüttel'
      },
      20255: {
        label: 'Eimsbüttel'
      },
      20257: {
        label: 'Eimsbüttel'
      }
    }
  }, {
    name: 'Hamburg-Nord',
    zipcodes: {
      22303: {
        label: 'Winterhude'
      },
      22305: {
        label: 'Barmbek-Nord'
      },
      22307: {
        label: 'Barmbek-Nord'
      },
      22309: {
        label: 'Steilshoop'
      }
    }
  }, {
    name: 'Wandsbek',
    zipcodes: {
      22041: {
        label: 'Wandsbek'
      },
      22043: {
        label: 'Wandsbek'
      },
      22047: {
        label: 'Wandsbek'
      },
      22049: {
        label: 'Wandsbek'
      }
    }
  }, {
    name: 'Bergedorf',
    zipcodes: {
      21029: {
        label: 'Bergedorf'
      },
      21031: {
        label: 'Bergedorf'
      },
      21033: {
        label: 'Bergedorf'
      }
    }
  }, {
    name: 'Harburg',
    zipcodes: {
      21073: {
        label: 'Harburg'
      },
      21075: {
        label: 'Harburg'
      },
      21077: {
        label: 'Harburg'
      }
    }
  }]
}, {
  id: 'LEIPZIG',
  name: 'Leipzig',
  country: 'DE',
  cornerNW: {
    latitude: 51.4094,
    longitude: 12.2714
  },
  cornerSE: {
    latitude: 51.2705,
    longitude: 12.4833
  },
  subZones: [{
    name: 'Leipzig',
    zipcodes: {
      '04103': {
        label: 'Zentrum-Ost'
      },
      '04105': {
        label: 'Zentrum-Nord'
      },
      '04107': {
        label: 'Zentrum-Süd'
      },
      '04109': {
        label: 'Zentrum'
      },
      '04129': {
        label: 'Gohlis-Süd'
      }
    }
  }]
}, {
  id: 'MUNICH',
  name: 'Munich',
  country: 'DE',
  cornerNW: {
    latitude: 48.1867,
    longitude: 11.4661
  },
  cornerSE: {
    latitude: 48.0616,
    longitude: 11.6649
  },
  subZones: [{
    name: 'Altstadt-Lehel',
    zipcodes: {
      80331: {
        label: 'Altstadt-Lehel'
      },
      80333: {
        label: 'Altstadt-Lehel'
      },
      80335: {
        label: 'Altstadt-Lehel'
      },
      80336: {
        label: 'Altstadt-Lehel'
      },
      80538: {
        label: 'Altstadt-Lehel'
      },
      80539: {
        label: 'Altstadt-Lehel'
      }
    }
  }, {
    name: 'Aubing-Lochhausen-Langwied',
    zipcodes: {
      81243: {
        label: 'Aubing-Lochhausen-Langwied'
      },
      81245: {
        label: 'Aubing-Lochhausen-Langwied'
      },
      81249: {
        label: 'Aubing-Lochhausen-Langwied'
      }
    }
  }, {
    name: 'Au-Haidhausen',
    zipcodes: {
      81541: {
        label: 'Au-Haidhausen'
      },
      81667: {
        label: 'Au-Haidhausen'
      },
      81669: {
        label: 'Au-Haidhausen'
      },
      81671: {
        label: 'Au-Haidhausen'
      },
      81675: {
        label: 'Au-Haidhausen'
      },
      81677: {
        label: 'Au-Haidhausen'
      }
    }
  }, {
    name: 'Berg am Laim',
    zipcodes: {
      81673: {
        label: 'Berg am Laim'
      },
      81671: {
        label: 'Berg am Laim'
      },
      81677: {
        label: 'Berg am Laim'
      }
    }
  }, {
    name: 'Bogenhausen',
    zipcodes: {
      81675: {
        label: 'Bogenhausen'
      },
      81677: {
        label: 'Bogenhausen'
      },
      81679: {
        label: 'Bogenhausen'
      },
      81925: {
        label: 'Bogenhausen'
      },
      81927: {
        label: 'Bogenhausen'
      },
      81929: {
        label: 'Bogenhausen'
      }
    }
  }, {
    name: 'Feldmoching-Hasenbergl',
    zipcodes: {
      80933: {
        label: 'Feldmoching-Hasenbergl'
      },
      80935: {
        label: 'Feldmoching-Hasenbergl'
      },
      80995: {
        label: 'Feldmoching-Hasenbergl'
      },
      80997: {
        label: 'Feldmoching-Hasenbergl'
      }
    }
  }, {
    name: 'Hadern',
    zipcodes: {
      81375: {
        label: 'Hadern'
      },
      81377: {
        label: 'Hadern'
      }
    }
  }, {
    name: 'Laim',
    zipcodes: {
      80686: {
        label: 'Laim'
      },
      80687: {
        label: 'Laim'
      },
      80689: {
        label: 'Laim'
      }
    }
  }, {
    name: 'Ludwigsvorstadt-Isarvorstadt',
    zipcodes: {
      80336: {
        label: 'Ludwigsvorstadt-Isarvorstadt'
      },
      80469: {
        label: 'Ludwigsvorstadt-Isarvorstadt'
      }
    }
  }, {
    name: 'Maxvorstadt',
    zipcodes: {
      80333: {
        label: 'Maxvorstadt'
      },
      80335: {
        label: 'Maxvorstadt'
      },
      80539: {
        label: 'Maxvorstadt'
      }
    }
  }, {
    name: 'Milbertshofen-Am Hart',
    zipcodes: {
      80807: {
        label: 'Milbertshofen-Am Hart'
      },
      80809: {
        label: 'Milbertshofen-Am Hart'
      },
      80937: {
        label: 'Milbertshofen-Am Hart'
      }
    }
  }, {
    name: 'Moosach',
    zipcodes: {
      80992: {
        label: 'Moosach'
      },
      80993: {
        label: 'Moosach'
      },
      80995: {
        label: 'Moosach'
      },
      80997: {
        label: 'Moosach'
      }
    }
  }, {
    name: 'Neuhausen-Nymphenburg',
    zipcodes: {
      80634: {
        label: 'Neuhausen-Nymphenburg'
      },
      80636: {
        label: 'Neuhausen-Nymphenburg'
      },
      80637: {
        label: 'Neuhausen-Nymphenburg'
      },
      80638: {
        label: 'Neuhausen-Nymphenburg'
      }
    }
  }, {
    name: 'Obergiesing',
    zipcodes: {
      81539: {
        label: 'Obergiesing'
      },
      81541: {
        label: 'Obergiesing'
      },
      81547: {
        label: 'Obergiesing'
      },
      81549: {
        label: 'Obergiesing'
      }
    }
  }, {
    name: 'Pasing-Obermenzing',
    zipcodes: {
      81241: {
        label: 'Pasing-Obermenzing'
      },
      81243: {
        label: 'Pasing-Obermenzing'
      },
      81245: {
        label: 'Pasing-Obermenzing'
      },
      81247: {
        label: 'Pasing-Obermenzing'
      },
      81249: {
        label: 'Pasing-Obermenzing'
      }
    }
  }, {
    name: 'Ramersdorf-Perlach',
    zipcodes: {
      81735: {
        label: 'Ramersdorf-Perlach'
      },
      81737: {
        label: 'Ramersdorf-Perlach'
      },
      81739: {
        label: 'Ramersdorf-Perlach'
      }
    }
  }, {
    name: 'Schwabing-Freimann',
    zipcodes: {
      80805: {
        label: 'Schwabing-Freimann'
      },
      80807: {
        label: 'Schwabing-Freimann'
      }
    }
  }, {
    name: 'Schwabing-West',
    zipcodes: {
      80796: {
        label: 'Schwabing-West'
      },
      80797: {
        label: 'Schwabing-West'
      },
      80798: {
        label: 'Schwabing-West'
      }
    }
  }, {
    name: 'Schwanthalerhöhe',
    zipcodes: {
      80339: {
        label: 'Schwanthalerhöhe'
      }
    }
  }, {
    name: 'Sendling',
    zipcodes: {
      81369: {
        label: 'Sendling'
      },
      81371: {
        label: 'Sendling'
      }
    }
  }, {
    name: 'Sendling-Westpark',
    zipcodes: {
      81373: {
        label: 'Sendling-Westpark'
      },
      81377: {
        label: 'Sendling-Westpark'
      },
      81379: {
        label: 'Sendling-Westpark'
      }
    }
  }, {
    name: 'Thalkirchen-Obersendling-Forstenried-Furstenried-Solln',
    zipcodes: {
      81475: {
        label: 'Solln'
      },
      81476: {
        label: 'Fürstenried'
      },
      81477: {
        label: 'Forstenried'
      },
      81479: {
        label: 'Thalkirchen, Obersendling'
      }
    }
  }, {
    name: 'Trudering-Riem',
    zipcodes: {
      81825: {
        label: 'Trudering-Riem'
      },
      81827: {
        label: 'Trudering-Riem'
      },
      81829: {
        label: 'Trudering-Riem'
      }
    }
  }, {
    name: 'Untergiesing-Harlaching',
    zipcodes: {
      81547: {
        label: 'Untergiesing-Harlaching'
      }
    }
  }]
}, {
  id: 'STUTTGART',
  name: 'Stuttgart',
  country: 'DE',
  cornerNW: {
    latitude: 48.8461,
    longitude: 9.1036
  },
  cornerSE: {
    latitude: 48.6934,
    longitude: 9.2793
  },
  subZones: [{
    name: 'Stuttgart',
    zipcodes: {
      70173: {
        label: 'Stadtbezirk Mitte'
      },
      70174: {
        label: 'Stadtbezirk Nord'
      },
      70176: {
        label: 'Stadtbezirk West'
      },
      70178: {
        label: 'Stadtbezirk Süd'
      },
      70180: {
        label: 'Stadtbezirk Ost'
      }
    }
  }]
}];
var deSubZoneNameMapping = exports.deSubZoneNameMapping = [{
  old: 'Berlin Mitte',
  "new": 'Mitte'
}, {
  old: 'Berlin Tiergarten',
  "new": 'Mitte'
}, {
  old: 'Berlin Friedrichshain',
  "new": 'Mitte'
}, {
  old: 'Berlin Prenzlauer Berg',
  "new": 'Mitte'
}, {
  old: 'Berlin Lichtenberg',
  "new": 'Friedrichshain-Kreuzberg'
}, {
  old: 'Berlin Charlottenburg',
  "new": 'Charlottenburg-Wilmersdorf'
}, {
  old: 'Berlin Neukölln',
  "new": 'Neukölln'
}, {
  old: 'Berlin Treptow',
  "new": 'Neukölln'
}, {
  old: 'Berlin Reinickendorf',
  "new": 'Reinickendorf'
}, {
  old: 'Munich',
  "new": 'Altstadt-Lehel'
}, {
  old: 'Frankfurt',
  "new": 'Innenstadt I'
}, {
  old: 'Hamburg',
  "new": 'Hamburg-Mitte'
}, {
  old: 'Cologne',
  "new": 'Innenstadt'
}];